import React from "react";
import SEO from "../components/SEO";
import { NotFoundContent } from "../components/ui/ghost-404-page";

const NotFoundScreen: React.FC = () => {
  return (
    <div className="min-h-[75vh] flex flex-col items-center justify-center px-4 relative mt-16">
      <SEO
        title="Page Not Found | InnovaTech"
        description="The page you are looking for does not exist."
        noindex={true}
      />

      {/* Background elements to match the hero section */}
      <div className="absolute inset-0 technical-grid-bg opacity-30 pointer-events-none"></div>

      <NotFoundContent />
    </div>
  );
};

export default NotFoundScreen;
